var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({attrs:{"id":_vm.id,"type":"text","outlined":"","label":_vm.label},on:{"input":_vm.onInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }